document.addEventListener('turbolinks:load', function () {
  $('.heatmap_preset_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.heatmap_preset_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.heatmap_preset_slidedown_btn').fadeIn(0));
  });

  $('.heatmap_preset_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.heatmap_preset_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.heatmap_preset_slideup_btn').fadeIn(0));
  });

  // #################################################################
  // ヒートマップ管理の切り替え
  // #################################################################
  $('.heatmap_preset_select_box').on('change', function () {
    let heatmap_preset_id = $('.heatmap_preset_select_box option:selected').val();
    if (heatmap_preset_id == 'new') {
      $('.heatmap_preset_set_wrapper_display').css('display', 'block');
      $('.heatmap_preset_name_setting_wrapper').css('display', 'none');
      $('.heatmap_preset_description_setting_wrapper').css('display', 'none');
      $('.heatmap_preset_url_setting_wrapper').css('display', 'none');

    } else {
      location.href = `/heatmap_preset/index?heatmap_preset_id=${heatmap_preset_id}`;
    }
  });

  // #################################################################
  // ヒートマップ管理の新規作成
  // #################################################################
  $('#heatmap_preset_create').on('click', function () {
    const url = $('.heatmap_preset_url_input').val();
    const name = $('.heatmap_preset_name_input').val();
    const description = $('.heatmap_preset_description_input').val();

    if (!name) {
      alert('ヒートマップ名を入力して下さい。');
      return;
    }

    if (!url) {
      alert('URLを入力して下さい。');
      return;
    }

    $.ajax({
      url: '/create_heatmap_preset',
      type: 'POST',
      data: {
        name: name,
        url: url,
        description: description,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('新規登録されました。');
        location.href = `/heatmap_preset/index?heatmap_preset_id=${data.heatmap_preset_id}`;
      }else{
        alert('登録に失敗しました。\n' + data.message);
      }
    })
    .fail(function (data) {
      alert('登録に失敗しました。');
    })
  });

  // #################################################################
  // ヒートマップ管理名の編集
  // #################################################################
  $('#heatmap_preset_name_edit_btn').on('click', function () {
    let heatmap_preset_id = $('.heatmap_preset_select_box option:selected').val();
    let name = $('.heatmap_preset_name_val').val();

    if (!name) {
      alert('名称を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/save_heatmap_preset_name',
      type: 'POST',
      data: {
        heatmap_preset_id: heatmap_preset_id,
        name: name
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('保存されました。')
        location.reload();
      }else{
        alert('保存に失敗しました。\n'+data.message);
      }
    })
    .fail(function (data) {
      alert('登録に失敗しました。');
    })
  });

  // #################################################################
  // ヒートマップ管理説明の編集
  // #################################################################
  $('#heatmap_preset_description_edit_btn').on('click', function () {
    let heatmap_preset_id = $('.heatmap_preset_select_box option:selected').val();
    let description = $('.heatmap_preset_description_val').val();

    if (!description) {
      alert('説明を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/save_heatmap_preset_description',
      type: 'POST',
      data: {
        heatmap_preset_id: heatmap_preset_id,
        description: description
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('保存されました。')
        location.reload();
      }else {
        alert('保存に失敗しました。\n'+data.message);
      }
    })
    .fail(function (data) {
      alert('登録に失敗しました。');
    })
  });

  // #################################################################
  // ヒートマップ管理URLの編集
  // #################################################################
  $('#heatmap_preset_url_edit_btn').on('click', function () {
    let heatmap_preset_id = $('.heatmap_preset_select_box option:selected').val();
    let url = $('.heatmap_preset_url_val').val();

    if (!url) {
      alert('URLを記入して下さい。');
      return;
    }

    $.ajax({
      url: '/save_heatmap_preset_url',
      type: 'POST',
      data: {
        heatmap_preset_id: heatmap_preset_id,
        url: url
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('保存されました。')
        location.reload();
      }else{
        alert('保存に失敗しました。\n'+data.message);
      }
    })
    .fail(function (data) {
      alert('登録に失敗しました。');
    })
  });

  // #################################################################
  // ヒートマッププリセットの削除
  // #################################################################
  $('#delete-heatmap-preset').on('click', function () {
    let heatmap_preset_id = $('.heatmap_preset_select_box option:selected').val();
    let heatmapTitle = $('.heatmap_preset_select_box option:selected').text();
    if (!confirm('このヒートマッププリセットを削除しますか？')) {
      return;
    }
    $.ajax({
      url: '/delete_heatmap_preset',
      type: 'POST',
      data: {
        heatmap_preset_id: heatmap_preset_id
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert(`${heatmapTitle} を削除しました。`)
        location.href = '/heatmap_preset/index';
      }
    })
    .fail(function (data) {
      alert('削除に失敗しました。');
    })
  });


  /**
   * ヒートマップレポート
   */
  if ($('#heatmap-preset-report-wrapper').length) {
    let _heatmapPresetId = $('#heatmap-preset-id').val();
    let _heatmapDevice = $('#heatmap-device').val();
    let _heatmapReportType = $('#heatmap-report-type').val();
    /**
     * 項目の更新時イベント定義
     */
    // プリセットの選択
    $('#heatmap-preset-select').on('change', function () {
      _heatmapPresetId = $(this).val();
      update_heatmap_report();
    });
    // 日付の範囲選択
    $('#heatmap-start-date, #heatmap-end-date').on('change', function () {
      update_heatmap_report();
    });
    // デバイスの切り替え
    $('.heatmap-device-btn').on('click', function () {
      _heatmapDevice = $(this).attr('data-device');
      update_heatmap_report();
    });
    // レポート種別の切り替え
    $('.heatmap-report-type-btn').on('click', function () {
      _heatmapReportType = $(this).attr('data-report-type');
      update_heatmap_report();
    });

    function update_heatmap_report() {
      let startDate = $('#heatmap-start-date').val();
      let endDate = $('#heatmap-end-date').val();
      // startDateよりもendDateが前の場合は、入れ替える
        if (startDate > endDate) {
            let tmp = startDate;
            startDate = endDate;
            endDate = tmp;
        }
      location.href = `/heatmap_preset/report?id=${_heatmapPresetId}&device=${_heatmapDevice}&type=${_heatmapReportType}&start_date=${startDate}&end_date=${endDate}`;
    }
  }



  // #################################################################
  /**
   * クリックヒートマップ
   *
   * ライブラリのheatmap.jsを利用。
   * #heatmapContainerに対して、renderClickHeatmapイベントを設定。triggerで呼び出す。
   * _heatmap_data_jsonはviewでグローバル変数として埋め込んでいる。
   */
  $('#heatmapContainer').on('renderClickReport', function() {
    let heatmapContainer = document.getElementById('heatmapContainer');
    let config = {
      container: heatmapContainer,
      radius: 25,
      maxOpacity: .5,
      minOpacity: .1,
      blur: .75
    };
    let heatmapInstance = h337.create(config);

    // x, y座標はパーセントで記録されているので、heatmapContainerの横幅から実数を算出する
    // XPathから要素を検索し、存在するなら座標を登録していく
    let dataPoint = _heatmap_data_json;
    let calcDataPoint = [];
    let iframe = document.getElementsByTagName('iframe')[0];
    let iframeDoc = iframe.contentWindow.document;
    for (let i = 0; i < dataPoint.length; i++) {
      let point = dataPoint[i];
      // XPathから要素を検索
      let element = iframeDoc.evaluate(point.xpath, iframeDoc, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
      // display:noneの要素は無視する
      if (element && getComputedStyle(element).display === 'none') {
          continue;
      }
      // 要素が存在する場合は、座標を計算する
      if (element) {
        // 要素の座標を一括取得
        let rect = element.getBoundingClientRect();
        let x = Math.round(rect.left + rect.width * point.localX / 100);
        let y = Math.round(rect.top + rect.height * point.localY / 100);
        calcDataPoint.push({
          x: x,
          y: y,
          value: 1
        });
      }else{
        console.log("要素が存在しませんでした: " + point.xpath);
      }
    }
    heatmapInstance.addData(calcDataPoint);
  });


  /**
   * アテンションヒートマップ
   * #heatmapContainerに対して、renderAttentionReportイベントを設定。triggerで呼び出す。
   * _heatmap_data_jsonはviewでグローバル変数として埋め込んでいる。
   */
  $('#heatmapContainer').on('renderAttentionReport', function () {
    initializeScrollHeatmapElements(_heatmap_data_json);
  });

  /**
   * スクロールヒートマップ
   * #heatmapContainerに対して、renderScrollReportイベントを設定。triggerで呼び出す。
   * _heatmap_data_jsonはviewでグローバル変数として埋め込んでいる。
   */
  $('#heatmapContainer').on('renderScrollReport', function () {
    initializeScrollHeatmapElements(_heatmap_data_json);
  });


  function initializeScrollHeatmapElements(scroll_heatmap) {
    const css = platta_scroll_heatmap_css(scroll_heatmap);
    // スタイルタグを作成する
    create_scroll_heatmap_css_style_element(css);
    create_scroll_heatmap_overlay(scroll_heatmap);
  }

  function create_scroll_heatmap_css_style_element(css) {
    $('body').append(`<style id="platta_scroll_heatmap_css">${css}</style>`);
  }

  function create_scroll_heatmap_overlay() {
    $('#heatmapContainer').append(`
                        <div id="platta_scroll_heatmap__hp" class="platta_scroll_heatmap__hp"></div>
                        <div id="platta_scroll_heatmap__modal_whole" class="platta_scroll_heatmap__modal_wrap">
                          <div class="platta_heatmap__container">
                            <div class="platta_heatmap__content">
                                <p class="platta_scroll_heatmap__label_0"><span class="platta_scroll_heatmap__legend">0%</span></p>
                                <p class="platta_scroll_heatmap__label_25"><span class="platta_scroll_heatmap__legend">25%</span></p>
                                <p class="platta_scroll_heatmap__label_50"><span class="platta_scroll_heatmap__legend">50%</span></p>
                                <p class="platta_scroll_heatmap__label_75"><span class="platta_scroll_heatmap__legend">75%</span></p>
                                <p class="platta_scroll_heatmap__label_100"><span class="platta_scroll_heatmap__legend">100%</span></p>
                            </div>
                          </div>
                        </div>`);
  }

  /**
   * アテンション、スクロールヒートマップのCSSを作成する
   */
  function platta_scroll_heatmap_css(top_to_end_user_ratio) {
    // ヒートマップデータは、下記をHTMLに埋め込む。100分割して数値を割り振る。グローバルに埋め込む。
    // let top_to_end_user_ratio = {
    //   0: 100, 2: 98.5, 4: 96.5, 6: 96, 8: 96, 10: 92, 12: 91.5, 14: 89.5, 16: 87.5, 18: 85.5,
    //   20: 83.5, 22: 81.5, 24: 79.5, 26: 77.5, 28: 75.5, 30: 73.5, 32: 71.5, 34: 69.5, 36: 59,
    //   38: 55, 40: 51, 42: 47, 44: 43, 46: 39, 48: 33, 50: 29, 52: 29, 54: 29, 56: 29, 58: 29,
    //   60: 29, 62: 28.5, 64: 26.5, 66: 24.5, 68: 22.5, 70: 20.5, 72: 18.5, 74: 15.5, 76: 11,
    //   78: 7.5, 80: 5, 82: 5, 84: 5, 86: 5, 88: 5, 90: 5, 92: 3.5, 94: 1.5, 96: 0, 98: 0
    // };

    let options = [100, 98, 96, 94, 92, 90, 88, 86, 84, 82, 80, 78, 76, 74, 72, 70, 68, 66, 64, 62, 60,
      58, 56, 54, 52, 50, 48, 46, 44, 42, 40, 38, 36, 34, 32, 30, 28, 26, 24, 22, 20, 18,
      16, 14, 12, 10, 8, 6, 4, 2, 0];

    // top_to_end_user_ratio を gradation定数に当てはまるように、それぞれのvalueを
    // 2%ごとの各近似値に置き換え、objectで返す
    function convertShmStyle(top_to_end_user_ratio) {
      // PC用のデータのみを利用
      top_to_end_user_ratio = top_to_end_user_ratio['percentage_pc'];

      let result = {};
      for (let k in top_to_end_user_ratio) {
        let v = top_to_end_user_ratio[k];
        let closest = options.reduce((prev, curr) => {
          // console.log('prev :>> ', prev);
          // console.log('curr :>> ', curr);
          return (Math.abs(curr - v) < Math.abs(prev - v) ? curr : prev);
        });
        result[k] = closest;
      }
      return result;
    }

    let updated_top_to_end_user_ratio = convertShmStyle(top_to_end_user_ratio);

    // エンドユーザーの割合によって表示するグラデーション郡
    const gradation = {
      // エンドユーザーの割合 : 色 : 画面一番上からの%
      100: 'rgba(255, 0, 0, 1)',
      98: 'rgba(255, 18, 0, 1)',
      96: 'rgba(255, 27, 0, 1)',
      94: 'rgba(255, 37, 0, 1)',
      92: 'rgba(255, 64, 0, 1)',
      90: 'rgba(255, 90, 0, 1)',
      88: 'rgba(255, 100, 0, 1)',
      86: 'rgba(255, 105, 0, 1)',
      84: 'rgba(255, 110, 0, 1)',
      82: 'rgba(255, 119, 0, 1)',
      80: 'rgba(255, 122, 0, 1)',
      78: 'rgba(255, 125, 0, 1)',
      76: 'rgba(255, 138, 0, 1)',
      74: 'rgba(254, 152, 0, 1)',
      72: 'rgba(253, 170, 0, 1)',
      70: 'rgba(252, 188, 0, 1)',
      68: 'rgba(251, 206, 0, 1)',
      66: 'rgba(250, 224, 0, 1)',
      64: 'rgba(248, 230, 0, 1)',
      62: 'rgba(244, 234, 0, 1)',
      60: 'rgba(240, 240, 0, 1)',
      58: 'rgba(236, 245, 0, 1)',
      56: 'rgba(231, 255, 0, 1)',
      54: 'rgba(214, 255, 0, 1)',
      52: 'rgba(196, 255, 0, 1)',
      50: 'rgba(175, 255, 8, 1)',
      48: 'rgba(153, 255, 24, 1)',
      46: 'rgba(132, 255, 39, 1)',
      44: 'rgba(114, 255, 53, 1)',
      42: 'rgba(96, 255, 67, 1)',
      40: 'rgba(77, 255, 81, 1)',
      38: 'rgba(69, 248, 80, 1)',
      36: 'rgba(61, 241, 80, 1)',
      34: 'rgba(52, 234, 79, 1)',
      32: 'rgba(44, 228, 79, 1)',
      30: 'rgba(35, 221, 78, 1)',
      28: 'rgba(29, 215, 97, 1)',
      26: 'rgba(23, 209, 116, 1)',
      24: 'rgba(17, 203, 134, 1)',
      22: 'rgba(11, 198, 153, 1)',
      20: 'rgba(4, 192, 172, 1)',
      18: 'rgba(14, 185, 189, 1)',
      16: 'rgba(25, 178, 206, 1)',
      14: 'rgba(35, 171, 222, 1)',
      12: 'rgba(40, 167, 230, 1)',
      10: 'rgba(56, 156, 255, 1)',
      8: 'rgba(45, 135, 255, 1)',
      6: 'rgba(34, 113, 255, 1)',
      4: 'rgba(23, 91, 255, 1)',
      2: 'rgba(6, 58, 255, 1)',
      0: 'rgba(0, 47, 255, 1)'
    }

    // -- style の background-image: linear-gradient();の中身を作成する
    const key_array = [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98];

    function create_linear_gradient_style(gradation, updated_top_to_end_user_ratio) {
      let result = $.map(key_array, function (val_key, _index) {
        return `${gradation[updated_top_to_end_user_ratio[val_key]]} ${val_key}%,`
      });
      // 最後の要素のコンマ()を取り除く
      result = result.join('').trim().replace(/,$/, "");
      return result;
    }

    let linear_gradient_style_content = create_linear_gradient_style(gradation, updated_top_to_end_user_ratio)
    const scroll_heatmap_height = "200px";

    let heatmap__content_width;
    let heatmap__content_height;
    let heatmap__content_top;
    let heatmap__content_right ;

    let heatmap__container_width;
    let heatmap__container_height;
    let heatmap__container_top;
    let heatmap__container_right;

    let heatmap__label_0_top;
    let heatmap__label_25_top;
    let heatmap__label_50_top;
    let heatmap__label_75_top;
    let heatmap__label_100_top;

    heatmap__content_width = "100px"
    heatmap__content_height = "200px"
    heatmap__content_top = "50px"
    heatmap__content_right = "70px"

    heatmap__container_width = "200px"
    heatmap__container_height = "240px"
    heatmap__container_top = "30px"
    heatmap__container_right = "20px"

    heatmap__label_0_top = "0px"
    heatmap__label_25_top = "30px"
    heatmap__label_50_top = "60px"
    heatmap__label_75_top = "90px"
    heatmap__label_100_top = "120px"

    let scroll_heatmap_style = `
    .platta_heatmap__content {
      font-family: poppins, Helvetica, Arial, sans-serif;
      font-size: 12px;
      color: white !important;
      box-shadow: 0px 10px 50px gray;
      border-radius:5px;
      position: fixed;
      z-index: 9999999999;
      top: ${heatmap__content_top};
      right: ${heatmap__content_right};
      width: ${heatmap__content_width};
      height: ${heatmap__content_height};
      background-image: linear-gradient(
        ${linear_gradient_style_content}
      );
    }
    `;

    // ヒートマップを見やすくするためのバックグラウンドカラーを設定
    scroll_heatmap_style += `
    .platta_heatmap__container {
    display: none; // 管理画面レポートではミニマップは非表示
    width: ${heatmap__container_width};
    height: ${heatmap__container_height};
    margin: 0;
    padding: 0;
    position: fixed;
    z-index: 999999999;
    top: ${heatmap__container_top};
    right: ${heatmap__container_right};
    background-color: black !important;
    padding: 2px;
    border-radius: 10px;
    box-shadow: 0px 10px 50px gray;
    }
    `;

    let label_common_style = `
    line-height: 21px;
    font-family: inherit;
    position: relative;
    font-size: inherit;
    color: inherit;
    transform: translateY(-50%);
    text-align: right;
    right: -40px;
    margin: 0;
    padding: 0;
  `;

    scroll_heatmap_style += `
    .platta_scroll_heatmap__label_0 {
      ${label_common_style}
      top: ${heatmap__label_0_top};
    }

    .platta_scroll_heatmap__label_25 {
      ${label_common_style}
      top: ${heatmap__label_25_top};
    }

    .platta_scroll_heatmap__label_50 {
      ${label_common_style}
      top: ${heatmap__label_50_top};
    }

    .platta_scroll_heatmap__label_75 {
      ${label_common_style}
      top: ${heatmap__label_75_top};
    }

    .platta_scroll_heatmap__label_100 {
      ${label_common_style}
      top: ${heatmap__label_100_top};
    }
    `;

    // webページ全体をヒートマップの対象にするため、高さを取得する
    let docHeight = $('#heatmapContainer').height();
    $('.platta_scroll_heatmap__hp').height(docHeight);
    // webページ全体
    scroll_heatmap_style += `
      .platta_scroll_heatmap__hp {
      position: absolute;
      top:0;
      left:0;
      min-with: 100%;
      min-height: 100%;
      width: 100%;
      height: ${docHeight}px;
      z-index: 99999999;
      opacity: 0.7;
      background-image: linear-gradient(
        ${linear_gradient_style_content}
      );
    }
    `;
    return scroll_heatmap_style;
  }


});
